import { render, staticRenderFns } from "./IdentityResources.vue?vue&type=template&id=219fe802&"
import script from "./IdentityResources.vue?vue&type=script&lang=js&"
export * from "./IdentityResources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports